<template>
  <div class="framer-13zyx1k" data-framer-name="Benefits section" name="Benefits section">
    <div class="ssr-variant hidden-15sd5ma hidden-72rtr7">
      <div class="framer-gi0hng-container">
        <div class="framer-DQ9hF framer-Wyb5v framer-EFfIX framer-1f6b38c framer-v-1f6b38c"
          data-framer-name="Primary"
          style="background-color: var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, rgb(255, 84, 0)); border-radius: 20px; max-width: 100%; width: 100%; opacity: 1;">
          <div class="framer-p6tyit" data-framer-name="Inner layer"
            style="background-color: var(--token-8bb1a94f-ff66-4f61-9be2-a74ae20c49b5, rgb(255, 110, 10)); border-radius: 16px; mask: linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%); opacity: 1;">
          </div>
          <div class="framer-c42u5s"
            style="background-color: var(--token-fe65a76b-2bec-47ef-8ad1-5fc7a52718d1, rgb(255, 84, 0)); transform: rotate(-45deg); opacity: 1;">
          </div>
          <div class="framer-18g1k00" style="opacity: 1;">
            <div class="framer-vqzk2o"
              style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-gdpscs: var(--token-29ae30f0-796c-4dca-b80f-404f436e4da7, rgb(252, 247, 240)); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;"
              data-framer-component-type="RichTextContainer">
              <h1 class="framer-text framer-styles-preset-11ocsv1" data-styles-preset="aR6jbEIVm"
                style="--framer-text-color:var(--extracted-gdpscs, var(--token-29ae30f0-796c-4dca-b80f-404f436e4da7, rgb(252, 247, 240)))">
                Are you ready to transform your factory into a smart factory?</h1>
            </div>
            <div class="framer-87hnv1"
              style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-r6o4lv: var(--token-29ae30f0-796c-4dca-b80f-404f436e4da7, rgb(252, 247, 240)); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;"
              data-framer-component-type="RichTextContainer">
              <p class="framer-text framer-styles-preset-1fbpo4z" data-styles-preset="p_THf0xIU"
                style="--framer-text-color:var(--extracted-r6o4lv, var(--token-29ae30f0-796c-4dca-b80f-404f436e4da7, rgb(252, 247, 240)))">
                Join thousands of manufacturers accelerating their digital transformation with the Smart Factory Recognition Program
                programme. Unlock advanced technologies, matching grants, and expert support to enhance efficiency
                and competitiveness.</p>
            </div>
          </div>
          <div class="framer-1yb5zhm-container" style="opacity: 1;"><!--$--><a
              class="framer-rfsh1 framer-EFfIX framer-z36m5w framer-v-1wafxef framer-mzz8vh" data-border="true"
              data-framer-name="Secondary"
              style="--border-bottom-width: 1px; --border-color: var(--token-72e8df52-57a2-46b1-82a3-f1511a4cdd86, rgb(16, 16, 16)); --border-left-width: 1px; --border-right-width: 1px; --border-style: solid; --border-top-width: 1px; background-color: var(--token-29ae30f0-796c-4dca-b80f-404f436e4da7, rgb(253, 253, 252)); border-radius: 8px; box-shadow: rgba(0, 0, 0, 0.125) 0.301094px 0.602187px 0.673266px -0.833333px, rgba(0, 0, 0, 0.125) 1.14427px 2.28853px 2.55866px -1.66667px, rgba(0, 0, 0, 0.125) 5px 10px 11.1803px -2.5px; opacity: 1;"
              href="/login" rel="noopener">
              <div class="framer-1tcn8yf" data-framer-name="Inner layer"
                style="background-color: var(--token-72e8df52-57a2-46b1-82a3-f1511a4cdd86, rgb(16, 16, 16)); border-radius: 6px; box-shadow: rgba(0, 0, 0, 0.157) 0px -0.361312px 0.939412px -1.08333px inset, rgba(0, 0, 0, 0.145) 0px -1.37312px 3.57011px -2.16667px inset, rgba(0, 0, 0, 0.086) 0px -6px 15.6px -3.25px inset; opacity: 1;">
              </div>
              <div class="framer-3j2np" data-framer-name="Text" style="opacity: 1;">
                <div class="framer-bjww99"
                  style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;"
                  data-framer-component-type="RichTextContainer">
                  <p class="framer-text framer-styles-preset-1fbpo4z" data-styles-preset="p_THf0xIU">Yes, I'm ready
                    to Transform</p>
                </div>
                <div class="framer-8u2rgs"
                  style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;"
                  data-framer-component-type="RichTextContainer">
                  <p class="framer-text framer-styles-preset-1fbpo4z" data-styles-preset="p_THf0xIU">Yes, I'm ready
                    to Transform</p>
                </div>
              </div>
            </a><!--/$--></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'part-6-landing-page',
  inheritAttrs: false,
  data() {
    return {}
  }
}
</script>


// WEBPACK FOOTER //
// src/views/msma/components/Part6LandingPage/index.vue